import React from "react"

import { useRecoilValue } from "recoil"

import {
  tracingFacesState,
  tracingPlaybackState,
} from "./tracing-visualization-state"
import { RainbowFacesPlayback } from "../Visuals/RainbowFacesPlayback"

export const TracingVisualization: React.FC = () => {
  const faceGroups = useRecoilValue(tracingFacesState)
  const playbackPosition = useRecoilValue(tracingPlaybackState)

  return (
    <>
      <RainbowFacesPlayback
        nodeGroups={faceGroups}
        playbackPosition={playbackPosition}
      />
    </>
  )
}
